<template>
  <div class="form-container elevation-1">
    <div class="banner"></div>
    <div class="form-container-right">
      <v-layout justify-end>
        <Logo class="ts-logo"/>
        <div class="ts-logo">
          ThinkSpatial
        </div>
      </v-layout>
      <h2 class="display-3">account confirmed</h2>
      <p class="title-1">You have successfully confirmed your email address. You can now sign in.</p>
      <div class="link-group">
        <router-link to="/signin" class="text-center blockify">Return to sign in</router-link>
      </div>
    </div>
  </div>  
</template>
<script>
import Logo from 'assets/svg/ts-logo-only.svg';

export default {
  created: () => {
    document.title = 'ThinkSpatial | Account Confirmed';
  },
  components: {
    Logo
  }    
}
</script>
<style lang="scss" scoped>
  @import 'assets/landing.scss';
</style>
